export const helpSheetId = 'jampad'
export const homeSheetId = 'home'

export function isBuiltInSheet(sheetId: string) {
  return sheetId === helpSheetId
}